module.exports = __webpack_public_path__ + "img/IMG_2212.a9774a68.jpg";